import { useEffect, useState } from "react";
import { AudioLines, Volume2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { play } from "../../lib/audio";
import { Slider } from "../ui/slider";
import { Input } from "../ui/input";

export const VoicePanel = () => {
  const [s, setS] = useState(null);
  const [text, setText] = useState("曹沖知道大象有多重。");
  useEffect(() => { api.get("/admin/tts").then(({ data }) => setS(data)); }, []);
  if (!s) return null;
  const google = s.provider === "google";
  const save = async () => {
    try { await api.put("/admin/tts", { voice: s.voice, rate: s.rate }); toast.success("Voice settings saved"); }
    catch { toast.error("Could not save voice settings"); }
  };
  const pregen = async () => {
    try { const { data } = await api.post("/admin/pregenerate-audio"); toast.success(`Audio generation started (${data.cached} clips cached so far)`); }
    catch { toast.error("Could not start audio generation"); }
  };
  return (
    <div className="scroll-card p-6 space-y-4" data-testid="voice-settings">
      <h3 className="font-bold flex items-center gap-2"><AudioLines size={18} /> Pronunciation voice</h3>
      <div data-testid="tts-provider" className={`text-sm px-3 py-2 rounded-xl ${google ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`}>
        {google ? "Google Taiwan Mandarin voice is active." : "Google key not set yet; the previous AI voice is used."}
      </div>
      <div className="flex flex-wrap gap-2">
        {s.voices.map((v) => (
          <button key={v} data-testid={`tts-voice-${v}`} onClick={() => setS({ ...s, voice: v })}
            className={`h-9 px-3 rounded-full border text-xs font-semibold ${s.voice === v ? "bg-[var(--jade)] text-white border-transparent" : "bg-white"}`}>
            {v.replace("cmn-TW-", "")}{v.endsWith("A") ? " · 女" : " · 男"}
          </button>
        ))}
      </div>
      <div>
        <div className="text-sm text-stone-600 mb-2">Speaking speed: <b data-testid="tts-rate-value">{s.rate.toFixed(2)}</b></div>
        <Slider data-testid="tts-rate-slider" min={50} max={150} step={5} value={[Math.round(s.rate * 100)]} onValueChange={([v]) => setS({ ...s, rate: v / 100 })} />
      </div>
      <button data-testid="save-tts-btn" onClick={save} className="h-10 px-5 rounded-full bg-[var(--vermilion)] text-white text-sm font-semibold">Save voice</button>
      <div className="flex gap-2 pt-2 border-t">
        <Input data-testid="tts-test-input" value={text} onChange={(e) => setText(e.target.value)} className="font-serif-tc" />
        <button data-testid="tts-test-play" onClick={() => play(text, null, { ai: true, fresh: true })} className="h-10 px-4 rounded-full bg-[var(--ink)] text-white text-sm flex items-center gap-1 shrink-0"><Volume2 size={16} /> 試聽</button>
      </div>
      <p className="text-xs text-stone-500">Wrong reading for a polyphone? Add it in the 讀音修正 tab (e.g. 多重 → ㄉㄨㄛ ㄓㄨㄥˋ), then test it here. Audio is created once and stored; changing voice, speed or a fix regenerates only what's affected.</p>
      <button data-testid="pregen-audio-btn" onClick={pregen} className="h-10 px-5 rounded-full bg-white border text-sm font-semibold">Pre-generate all audio</button>
    </div>
  );
};
